const DEFAULT_STATE: IHomePageOnboardModel = {
	title: 'Want Your Products on Beacon Discovery?',
	metrics: [
		{
			value: '30,000+',
			name: 'Products'
		},
		{
			value: '5900+',
			name: 'Brands'
		},
		{
			value: '2500+',
			name: 'Retailers Use Beacon'
		}
	],
	buttonTitle: 'Get Started'
};

interface IHomePageOnboardModel {
	title: string;
	metrics: { name: string; value: string }[];
	buttonTitle: string;
}
export const HomePageOnboardModel = {
	...DEFAULT_STATE
};
